var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(_vm.randomBanner.css_code)?_c('div',{domProps:{"innerHTML":_vm._s('<style>' + _vm.randomBanner.css_code + '</style>')}}):_vm._e(),_vm._v(" "),(_vm.randomBanner)?_c('div',{staticClass:"h-100 zone",domProps:{"innerHTML":_vm._s(_vm.randomBanner.html_code)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }